<template>
  <div class="i-quiz-insight">
    <div class="icon">{{ icon }}</div>
    <div class="title">{{ title }}</div>
    <div class="body">{{ body }}</div>
    <button
      class="btn"
      @click="$emit('continue')"
    >
      Continue
    </button>
  </div>
</template>

<script setup>
defineProps({
  icon: { type: String, default: "⊙" },
  title: String,
  body: String
})
defineEmits(["continue"])
</script>

<style lang="scss" scoped>
.i-quiz-insight {
  text-align: center;
  padding: 16px 0;

  @include respond-to($breakpoint-md) {
    padding: 20px 0;
  }

  .icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #1d4ed81a;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: $amber-mid;
    font-size: 26px;

    @include respond-to($breakpoint-md) {
      width: 64px;
      height: 64px;
      margin-bottom: 20px;
      font-size: 32px;
    }
  }

  .title {
    font-family: $serif;
    font-size: clamp(18px, 3.5vw, 24px);
    font-weight: 400;
    color: $ink;
    margin-bottom: 10px;
    line-height: 1.3;

    @include respond-to($breakpoint-md) {
      margin-bottom: 12px;
    }
  }

  .body {
    font-size: 14px;
    color: $ink-60;
    line-height: 1.7;
    max-width: 420px;
    margin: 0 auto 24px;

    @include respond-to($breakpoint-md) {
      font-size: 15px;
    }
  }

  .btn {
    display: inline-block;
    background: $amber-mid;
    color: $white;
    font-family: $sans;
    font-size: 15px;
    font-weight: 600;
    padding: 14px 36px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;
    width: 100%;

    @include respond-to($breakpoint-sm) {
      width: auto;
      min-width: 200px;
    }

    &:hover {
      opacity: 0.88;
    }
  }
}
</style>
